import { createContext, useEffect, useState } from "react";
import { getAllEntriesFromDB, getMultipleEntriesFromDB } from "./db";
import { useDispatch, useSelector } from "react-redux";
import { notify, manageErrorLogs } from "./commonFunction";
import { reqToUserLogoutProcess } from "../store/slice/offlineSlice";

const LocalDBContext = createContext();

const LocalDBProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { fetchLoader, syncLoader, logoutLoader } = useSelector(
    (state) => state.offlineReducer
  );
  const [isDataChanged, setIsDataChanged] = useState({
    userData: false,
    takedDetails: false,
  });
  const [localDBList, setLocalDBList] = useState({
    userData: null,
    activeCycle: [],
    takedDetails: [],
  });

  useEffect(() => {
    if (logoutLoader === true) {
      setLocalDBList((prev) => ({ ...prev, timeInOutData: [] }));
      dispatch(reqToUserLogoutProcess(false));
    }
  }, [logoutLoader]);

  useEffect(() => {
    if (fetchLoader === false || syncLoader === false) {
      handleGetInitialDBData();
    }
  }, [fetchLoader, syncLoader]);

  const handleGetInitialDBData = async () => {
    try {
      const fetchData = await getMultipleEntriesFromDB([
        "userData",
        "activeCycle",
        "takedDetails",
      ]);
      if (!fetchData || Object.keys(fetchData)?.length === 0) return;
      const { userData, activeCycle, takedDetails } = fetchData;
      setLocalDBList((prev) => ({
        ...prev,
        userData:
          Array.isArray(userData) && userData?.length > 0
            ? { ...userData[0] }
            : null,
        activeCycle: activeCycle,
        takedDetails: takedDetails,
      }));
    } catch (error) {
      manageErrorLogs(error);
      notify(
        error?.message || "Something went wrong when fetching initial data!"
      );
    }
  };

  useEffect(() => {
    if (isDataChanged?.takedDetails) {
      handleGetUpdatedData("TAKEDDETAILS");
    }
  }, [isDataChanged]);

  const handleGetUpdatedData = async (type) => {
    try {
      if (type === "TAKEDDETAILS") {
        const fetchData = await getMultipleEntriesFromDB(["takedDetails"]);
        if (!fetchData || Object.keys(fetchData)?.length === 0) return;
        const { takedDetails } = fetchData;
        setLocalDBList((prev) => ({
          ...prev,
          takedDetails: takedDetails,
        }));
        setIsDataChanged((prev) => ({
          ...prev,
          takedDetails: false,
        }));
      }
    } catch (error) {
      manageErrorLogs(error);
      notify(error.message || "Something went wrong when update local data!");
    }
  };

  const handleGetTableData = async (table) => {
    if (!table) return [];
    const tableData = await getAllEntriesFromDB(table);
    if (Array.isArray(tableData) && tableData?.length > 0) {
      return tableData;
    } else {
      return [];
    }
  };

  return (
    <LocalDBContext.Provider
      value={{
        localDBList,
        setLocalDBList,
        isDataChanged,
        setIsDataChanged,
        handleGetTableData,
      }}
    >
      {children}
    </LocalDBContext.Provider>
  );
};

export { LocalDBProvider };
export default LocalDBContext;
